import * as Yup from "yup"
import { transformSnakeToCamel } from "utils/transform"

import { ERROR_MESSAGES } from "constants/validation"

/**
 * Transaction Admin Schema
 * Represents administrative transactions in the system
 * Base schema is loose to allow loading legacy data.
 */
export const TransactionAdminSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    affiliateId: Yup.number().nullable(),
    transactionId: Yup.number().nullable(),
    transactionAmount: Yup.number().nullable(),
    transactionMonth: Yup.string()
      .oneOf([
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec",
      ])
      .nullable(),
    transactionDate: Yup.date().nullable(),
    transactionStatus: Yup.number().oneOf([1, 2]).nullable(),
  })

/**
 * Transaction Admin Validation Schema
 * Strict rules applied only during form submission.
 */
export const TransactionAdminValidationSchema = TransactionAdminSchema.clone().shape({
  transactionId: Yup.number().required(ERROR_MESSAGES.TRANSACTION_ID_REQUIRED),
  transactionAmount: Yup.number()
    .required(ERROR_MESSAGES.REQUIRED)
    .min(0, ERROR_MESSAGES.AMOUNT_MIN(0)),
  transactionMonth: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  transactionDate: Yup.date().required(ERROR_MESSAGES.REQUIRED),
  transactionStatus: Yup.number().oneOf([1, 2]).required(ERROR_MESSAGES.REQUIRED),
})
